import { PlayerComparisonRepository } from './playerComparisonRepository';

comparisonLoad($('body'));

function comparisonLoad(scope: JQuery<HTMLElement>) {
    scope.find('[data-funnel-counter]').each((i, e) => {
        const element = $(e);

        reloadFunnelCounter(element);
        PlayerComparisonRepository.setChangeNotification('funnelCounter', () => reloadFunnelCounter(element));

    });
}

function reloadFunnelCounter(funnelCounter: JQuery<HTMLElement>) {
    const comparisonIds = PlayerComparisonRepository.getComparisons();

    if (comparisonIds.length > 0 && funnelCounter) {
        funnelCounter.text('(' + comparisonIds.length + ')');
    }
    else {
        funnelCounter.text('');
    }
}
